import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import CatalogoInc from '../../../img/catalogoIncidentes2020.pdf';
import AccionesComunes from '../../AccionesComunes';

class CatalogoIncidentes extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("conoceSIJE");
        activeMenu.className += " active";
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Conoce el SIJE</span>
                        <span>Catálogo de incidentes</span>
                    </small>
                </div>
                {/* <Migajas /> */}
                <div className="col-md-12 text-center">
                    <h1 className="tituloPagina">Catálogo de incidentes</h1>
                    <p className="centrar">
                    Los incidentes SIJE son aprobados por las comisiones del Consejo General y se pueden clasificar en cinco grupos, según el momento en que pueden ocurrir:
                    </p>
                    <p className="centrar">
                        <a href={CatalogoInc} target="_blank" rel="noopener noreferrer">Descargar catálogo</a>
                    </p>
                </div>
                <div className="catalogoIncid" id="catalogoIncidentes">
                    <div>
                        <div className="renglonIncid" id="cabecera0" data-toggle="collapse" data-target="#colapso0" aria-controls="colapso0">
                            <h3>Casilla no instalada <span>(1 incidente)</span></h3>
                        </div>
                        <div className="collapse" id="colapso0" aria-labelledby="cabecera0" data-parent="#catalogoIncidentes">
                            <ul>
                                <li>
                                    <h4>1</h4>
                                    <p>Casilla no instalada</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="renglonIncid" id="cabecera1" data-toggle="collapse" data-target="#colapso1" aria-controls="colapso1">
                            <h3>Instalación de casillas <span>(2 incidentes)</span></h3>
                        </div>
                        <div className="collapse" id="colapso1" aria-labelledby="cabecera1" data-parent="#catalogoIncidentes">
                            <ul>
                                <li>
                                    <h4>2.1</h4>
                                    <p className="a">Cambio de lugar de la casilla sin causa justificada</p>
                                </li>
                                <li>
                                    <h4>2.2</h4>
                                    <p className="b">Cambio de lugar de la casilla con causa justificada</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="renglonIncid" id="cabecera2" data-toggle="collapse" data-target="#colapso2" aria-controls="colapso2">
                            <h3>Desarrollo de la votación <span>(23 incidentes)</span></h3>
                        </div>
                        <div className="collapse" id="colapso2" aria-labelledby="cabecera2" data-parent="#catalogoIncidentes">
                            <ul>
                                <li>
                                    <h4>3</h4>
                                    <p className="b">Recepción de la votación antes de las 08:00 horas</p>
                                </li>
                                <li>
                                    <h4>4</h4>
                                    <p className="b">Recepción de la votación por personas distintas a los facultados por la LGIPE</p>
                                </li>
                                <li>
                                    <h4>5.1</h4>
                                    <p className="a">Suspensión temporal de la votación por riesgo de violencia y/o violencia en la Casilla</p>
                                </li>
                                <li>
                                    <h4>5.2</h4>
                                    <p className="a">Suspensión temporal de la votación por condiciones climatológicas desfavorables que dificulten o impidan el acceso al lugar</p>
                                </li>
                                <li>
                                    <h4>5.3</h4>
                                    <p className="a">Suspensión temporal de la votación, otras causas</p>
                                </li>
                                <li>
                                    <h4>6.1</h4>
                                    <p className="b">Suspensión definitiva de la votación por riesgo de violencia y/o violencia en la Casilla</p>
                                </li>
                                <li>
                                    <h4>6.2</h4>
                                    <p className="b">Suspensión definitiva de la votación por robo y/o destrucción de la documentación o materiales electorales</p>
                                </li>
                                <li>
                                    <h4>6.3</h4>
                                    <p className="b">Suspensión definitiva de la votación por condiciones climatológicas desfavorables que dificulten o impidan el acceso al lugar</p>
                                </li>
                                <li>
                                    <h4>6.4</h4>
                                    <p className="b">Suspensión definitiva de la votación por otras causas</p>
                                </li>
                                <li>
                                    <h4>7</h4>
                                    <p className="a">Propaganda electoral en el interior o en el exterior de la Casilla</p>
                                </li>
                                <li>
                                    <h4>8</h4>
                                    <p className="a">No permitir el acceso a representantes ante la Casilla</p>
                                </li>
                                <li>
                                    <h4>9</h4>
                                    <p className="b">Algún elector votó sin Credencial para votar y/o sin aparecer en la Lista Nominal de Electores o listas adicionales</p>
                                </li>
                                <li>
                                    <h4>10</h4>
                                    <p className="a">Ausencia prolongada o definitiva de algún funcionario de la mesa directiva una vez instalada la Casilla</p>
                                </li>
                                <li>
                                    <h4>11.1.A</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún representante, por pretender asumir las funciones de los integrantes de la mesa directiva de casilla</p>
                                </li>
                                <li>
                                    <h4>11.1.B</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún representante, por promover o influir en el voto de los electores</p>
                                </li>
                                <li>
                                    <h4>11.1.C</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún representante, por otras causas</p>
                                </li>
                                <li>
                                    <h4>11.2.A</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún observador electoral, por pretender asumir las funciones de los integrantes de la mesa directiva de casilla</p>
                                </li>
                                <li>
                                    <h4>11.2.B</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún observador electoral, por promover o influir en el voto de los electores</p>
                                </li>
                                <li>
                                    <h4>11.2.C</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún observador electoral, por otras causas</p>
                                </li>
                                <li>
                                    <h4>11.3.A</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de otra persona ajena a la casilla, por pretender asumir las funciones de los integrantes de la mesa directiva de casilla</p>
                                </li>
                                <li>
                                    <h4>11.3.B</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de otra persona ajena a la casilla, por promover o influir en el voto de los electores</p>
                                </li>
                                <li>
                                    <h4>11.3.C</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de otra persona ajena a la casilla, por otras causas</p>
                                </li>
                                <li>
                                    <h4>12</h4>
                                    <p className="a">Obstaculización o interferencia en el desarrollo normal de la votación por parte de algún funcionario de la mesa directiva de casilla</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="renglonIncid" id="cabecera3" data-toggle="collapse" data-target="#colapso3" aria-controls="colapso3">
                            <h3>Cierre de la votación <span>(2 incidentes)</span></h3>
                        </div>
                        <div className="collapse" id="colapso3" aria-labelledby="cabecera3" data-parent="#catalogoIncidentes">
                            <ul>
                                <li>
                                    <h4>13</h4>
                                    <p className="a">Cierre de la votación antes de las 18:00 hrs, sin haber votado todos los electores incluidos en la Lista Nominal</p>
                                </li>
                                <li>
                                    <h4>14</h4>
                                    <p className="a">Mantener abierta la Casilla después de las 18:00 hrs, sin que se encuentren electores formados para votar</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="renglonIncid" id="cabecera4" data-toggle="collapse" data-target="#colapso4" aria-controls="colapso4">
                            <h3>Escrutinio y cómputo <span>(9 incidentes)</span></h3>
                        </div>
                        <div className="collapse" id="colapso4" aria-labelledby="cabecera4" data-parent="#catalogoIncidentes">
                            <ul>
                                <li>
                                    <h4>15.1</h4>
                                    <p className="a">Cambio de lugar de la Casilla para la realización del escrutinio y cómputo, sin causa justificada</p>
                                </li>
                                <li>
                                    <h4>15.2</h4>
                                    <p className="b">Cambio de lugar de la Casilla para la realización del escrutinio y cómputo, con causa justificada</p>
                                </li>
                                <li>
                                    <h4>16.1</h4>
                                    <p className="a">Suspensión temporal del escrutinio y cómputo por riesgo de violencia y/o violencia en la casilla</p>
                                </li>
                                <li>
                                    <h4>16.2</h4>
                                    <p className="a">Suspensión temporal del escrutinio y cómputo por condiciones climatológicas desfavorables que dificulten o impidan llevar a cabo el escrutinio y cómputo</p>
                                </li>
                                <li>
                                    <h4>16.3</h4>
                                    <p className="a">Suspensión temporal del escrutinio y cómputo por otras causas</p>
                                </li>
                                <li>
                                    <h4>17.1</h4>
                                    <p className="b">Suspensión definitiva del escrutinio y cómputo por riesgo de violencia y/o violencia en la Casilla</p>
                                </li>
                                <li>
                                    <h4>17.2</h4>
                                    <p className="b">Suspensión definitiva del escrutinio y cómputo por robo y/o destrucción de la documentación electoral</p>
                                </li>
                                <li>
                                    <h4>17.3</h4>
                                    <p className="b">Suspensión definitiva del escrutinio y cómputo por condiciones climatológicas desfavorables que dificulten o impidan llevar a cabo el escrutinio y cómputo</p>
                                </li>
                                <li>
                                    <h4>17.4</h4>
                                    <p className="b">Suspensión definitiva del escrutinio y cómputo por otras causas</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <p className="centrar">
                        <a href={CatalogoInc} target="_blank" rel="noopener noreferrer">Descargar catálogo</a>
                    </p>
                </div>
            </div>
        )
    }
}

export default CatalogoIncidentes;